const { fetchDoc, fetchCollection } = require("../../firebase");

const getAllTables = async (firebase, businessUid) => {
  const tables = [];
  const path = `floorplans/business/${businessUid}`;
  const floorplans = await fetchCollection(firebase, path);

  if (floorplans.length > 0) {
    for (const floorplan of floorplans) {
      const path = `floorplans/business/${businessUid}/${floorplan.uid}`;
      const floorplans = await fetchDoc(firebase, path);
      const { sections } = floorplans;

      if (sections.length > 0) {
        for (const section of sections) {
          const path = `tables/${businessUid}/sections/${section}/tables`;
          const tablesSnap = await fetchCollection(firebase, path);
          tablesSnap.forEach((item) =>
            tables.push({
              sectionUid: section,
              ...item,
              floorplan: floorplan.uid,
            })
          );
        }
      }
    }
  }

  return tables;
};

module.exports = {
  getAllTables,
};
